import { ChangeEvent } from 'react';

export default function handleFileChange(
  setPreview: (url: string) => void,
  setFile: (file: File) => void,
  setValidationError: (error: string) => void
) {
  return (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (!file) return;

    if (!file.type.startsWith('image/')) {
      setValidationError('Файл должен быть изображением');
      return;
    }

    setFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result as string);
      setValidationError('');
    };
    reader.readAsDataURL(file);
  };
}
